import React from 'react';
var Loader = function () {
    var circleCommonClasses = 'h-2.5 w-2.5 bg-current rounded-full';
    return (React.createElement("div", { className: "flex" },
        React.createElement("div", { className: circleCommonClasses + " mr-1 animate-bounce" }),
        React.createElement("div", { className: circleCommonClasses + " mr-1 animate-bounce" }),
        React.createElement("div", { className: circleCommonClasses + " animate-bounce" })));
};
export default Loader;
